"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UrlBuilder {
    constructor(url) {
        this.url = url;
    }
    getUrl() {
        return this.url;
    }
    setUrlParameters(urlParameters) {
        this.url = this.prepareUrlParameters(this.url, urlParameters);
        return this;
    }
    setQueryParameters(queryParameters) {
        this.url = this.prepareQueryParameters(this.url, queryParameters);
        return this;
    }
    prepareUrlParameters(url, urlParameters) {
        for (let property in urlParameters) {
            if (urlParameters.hasOwnProperty(property) && url.indexOf(`:${property}`) > -1) {
                url = url.replace(`:${property}`, urlParameters[property].toString());
            }
            else {
                throw new Error(`Parameter "${property}" does not exist in URL "${url}"`);
            }
        }
        return url;
    }
    prepareQueryParameters(url, queryParameters) {
        let firstProperty = true;
        for (let property in queryParameters) {
            if (queryParameters.hasOwnProperty(property) && queryParameters[property]) {
                url += firstProperty ? '?' : '&';
                firstProperty = false;
                url += `${property}=${encodeURIComponent(queryParameters[property].toString())}`;
            }
        }
        return url;
    }
}
exports.UrlBuilder = UrlBuilder;
